import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { fetchManagementSectionStatus } from '../../../services/managementService';
import PageShell from '../../../components/layout/PageShell';

// ✅ Custom breadcrumbs example:
// const crumbs = [
//   { label: 'Home', to: '/' },
//   { label: 'Community', to: `/community/${communityId}` },
//   { label: 'Match Manager', to: `/community/${communityId}/match-manager/${managerId}` },
//   { label: 'Manual Match Format' },
// ];
// <PageShell breadcrumbs={crumbs}>...</PageShell>
// <PageShell breadcrumbOverrides={{ tournamentId: tournament?.name || 'Tournament' }}>
const ComingSoonPage = () => {
  const { sectionId } = useParams();
  const location = useLocation();
  const fallbackSection = typeof location.state === 'object' ? location.state : {};
  const [section, setSection] = useState(fallbackSection);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadStatus = async () => {
      try {
        const data = await fetchManagementSectionStatus(sectionId);
        setSection((prev) => ({ ...prev, ...data }));
      } catch (err) {
        setError(err.message || 'Unable to load module status.');
      }
    };

    loadStatus();
  }, [sectionId]);

  return (
    <PageShell containerClassName="p-0">
    <div className="py-4 d-flex flex-column gap-3 align-items-start">
      <p className="eyebrow text-uppercase text-primary fw-semibold mb-0">Management module</p>
      <h1 className="h3 mb-1">{section.title || 'Coming soon'}</h1>
      {error ? (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      ) : (
        <>
          <p className="text-muted mb-0">{section.message || 'This area is being built and will be available soon.'}</p>
          <div className="badge bg-warning-subtle text-warning-emphasis">Coming soon</div>
        </>
      )}
    </div>
  
    </PageShell>
  );
};

export default ComingSoonPage;
